'use client';

import { TImageAssets } from '@/domain/Images.domain';
import { Slider } from './Slider';
import { usePartnerStore } from '@/service/state/Partner/usePartnerStore';

type TSliderCustomTextsProps = {
    slides: TImageAssets[];
    className?: string;
    price?: number;
};

export const SliderCustomTexts = ({ slides, className, price }: TSliderCustomTextsProps) => {
    const priceText = usePartnerStore((state) => state.texts?.['Starting at']);

    return <Slider slides={slides} className={className} price={price} priceText={priceText} />;
};
